import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import styled from "styled-components";

const SocialLink = styled.a`
  :hover {
    color: white;
  }
`;

export const Social = () => (
  <div className="social-media">
    <SocialLink href="https://www.facebook.com/Histo-Tech-Gmbh-471277912997912/">
      <FontAwesomeIcon icon={["fab", "facebook-square"]} />
    </SocialLink>
    <SocialLink href="https://instagram.com/histotech_cars">
      <FontAwesomeIcon icon={["fab", "instagram"]} />
    </SocialLink>
  </div>
);
export default Social;



// WEBPACK FOOTER //
// /opt/build/repo/src/components/social.js